import React from 'react';
import { galleryData } from '../mockData';
import { Card } from './ui/card';

const Gallery = () => {
  return (
    <section id="gallery" className="py-24">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Studio Gallery
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Take a look at my professional home studio featuring two complete drumsets and comprehensive teaching environment
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {galleryData.map((item) => {
            // Special positioning for Felix at Piano and Live Performance to show full head
            const objectPosition = 
              item.id === 1 ? 'center top' :  // Felix at Piano
              item.id === 2 ? 'center 20%' :   // Live Performance - shift down slightly to show head
              'center center';                  // Others use default
            
            return (
              <Card 
                key={item.id}
                className="bg-slate-900/80 border-indigo-500/30 overflow-hidden hover:border-indigo-400/50 transition-all hover:shadow-xl hover:shadow-indigo-500/10 group"
              >
                <div className="aspect-video bg-slate-800 relative overflow-hidden">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    style={{ objectPosition }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent"></div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-white mb-2">{item.title}</h3>
                  <p className="text-slate-400">{item.description}</p>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Gallery;